import { DefInstance, Entity, EntityRepository } from "~/utils";
import { DefType } from "../constant";
import { Card } from "./Card";
import { CardProps } from "./CardProps";

class CardDefRepository extends EntityRepository<CardProps & Entity> {
  fromName(name: string): Card {
    const cardDef = this.getById(name);
    return DefInstance.fromDef({ defId: cardDef.id, defName: DefType.Card });
  }
  getDef(card: Card) {
    return card.getDef(this);
  }
}

export const cardsDefRepository = new CardDefRepository({
  entities: [],
});
